import React from 'react';
import { Button } from './Button';

/**
 * Consistent page structure: Title, subtitle, primary CTA, secondary CTA.
 */
export function PageHeader({ title, subtitle, primaryAction, secondaryAction, className = '' }) {
  return (
    <header className={`ui-page-header ${className}`.trim()}>
      <div>
        <h1 className="ui-page-header__title">{title}</h1>
        {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
      </div>
      <div className="ui-page-header__actions">
        {secondaryAction && (
          <Button variant="ghost" onClick={secondaryAction.onClick} icon={secondaryAction.icon}>
            {secondaryAction.label}
          </Button>
        )}
        {primaryAction && (
          <Button variant="primary" onClick={primaryAction.onClick} icon={primaryAction.icon}>
            {primaryAction.label}
          </Button>
        )}
      </div>
    </header>
  );
}
